import { ReactNode, createContext, useContext } from 'react';
import usePostPartnerAccountBusinessCase from '../hooks/useApi/usePostPartnerAccountBusinessCase';

import type {
  PartnerAccountBusinessCaseRequest,
  PartnerAccountBusinessCaseResponse,
} from '../hooks/useApi/usePostPartnerAccountBusinessCase';

type PartnerAccountsBusinessCaseCtx = {
  response: PartnerAccountBusinessCaseResponse | undefined;
  postBusinessCase: (requestParams: PartnerAccountBusinessCaseRequest) => void;
  reset: () => void;
};

const defaultData = { success: false, errorMessage: '', accountDetails: {}, balances: [], permissions: {} };

export const PartnerAccountBusinessCaseContext = createContext<PartnerAccountsBusinessCaseCtx>({
  response: defaultData,
  postBusinessCase: () => {},
  reset: () => {},
});

export const PartnerAccountBusinessCaseProvider = ({ children }: { children: ReactNode }): React.JSX.Element => {
  const [response, postBusinessCase, reset] = usePostPartnerAccountBusinessCase({});

  return (
    <PartnerAccountBusinessCaseContext.Provider
      value={{
        response,
        postBusinessCase,
        reset,
      }}
    >
      {children}
    </PartnerAccountBusinessCaseContext.Provider>
  );
};

export const usePartnerAccountBusinessCase = (): PartnerAccountsBusinessCaseCtx =>
  useContext(PartnerAccountBusinessCaseContext);
